var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['result-status', _vm.type]},[_c('svg-icon',{style:({ fontSize: _vm.size }),attrs:{"name":_vm.icon,"class-name":"status-icon"}}),(_vm.title)?_c('p',{staticClass:"result-text"},[_vm._v(_vm._s(_vm.title))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }